import { h, Fragment } from 'preact'
import { useEffect, useRef } from 'preact/hooks'
import confetti from 'canvas-confetti'
import { Button } from '../button'
import { StepBody } from '../step-body'
import { StepFooter } from '../step-footer'
import { successIcon, bookingErrorIcon } from '../../shared/svgIcons'
import { closeWidget } from '../../shared/utils'
import AppointmentDetailsForWriteback from '../appointment-details/appointment-details-for-writeback'
import globalVars from '../../shared/global'

import * as style from './style.css'

interface Props {
    isBookingCompleted?: boolean
    isPMSWritebackEnabled?: boolean
    hasCustomRedirectEnabled?: boolean
    customRedirectUrl?: string
}

const colors = ['#FF5733', '#E9E610', '#FCC301', '#532DB8', '#0BA912', '#D566E5']

const confettiCreate = (canvas: any, endTime: number) => {
    const confettiContainer = confetti.create(canvas, { resize: true, useWorker: true })

    const confettiFrame = (endTime: number) => {
        confettiContainer({
            particleCount: 1,
            startVelocity: 0,
            ticks: 300,
            origin: {
                x: Math.random(),
                y: Math.random() - 0.2,
            },
            shapes: ['square'],
            colors: [colors[Math.floor(Math.random() * colors.length)]],
        })

        if (Date.now() < endTime) {
            requestAnimationFrame(() => confettiFrame(endTime))
        }
    }

    confettiFrame(endTime)
}

const Booked: preact.FunctionalComponent<Props> = ({
    isBookingCompleted = false,
    isPMSWritebackEnabled = true,
    hasCustomRedirectEnabled = false,
    customRedirectUrl = '',
}) => {
    const confettiCanvas = useRef(null)

    useEffect(() => {
        isBookingCompleted && confettiCreate(confettiCanvas.current, Date.now() + 5 * 1000)
    }, [isBookingCompleted])

    useEffect(() => {
        if (hasCustomRedirectEnabled && customRedirectUrl) {
            window.open(customRedirectUrl)
        }
    }, [hasCustomRedirectEnabled, customRedirectUrl])

    return (
        <Fragment>
            <section class={style.booked}>
                <StepBody>
                    <div class={style.bookedBody}>
                        <div class={style.bookedIcon}>{isBookingCompleted ? successIcon() : bookingErrorIcon()}</div>
                        {!isBookingCompleted && !isPMSWritebackEnabled && <AppointmentDetailsForWriteback />}
                        <h2 class={style.bookedTitle}>
                            {isBookingCompleted
                                ? `We'll send you an email with your appointment details!`
                                : 'We will contact you to confirm your appointment!'
                            }
                        </h2>
                    </div>
                </StepBody>
                {globalVars.isMounted ? <StepFooter onClose={closeWidget} /> : <StepFooter />}
            </section>
            <canvas class={style.bookedConfetti} ref={confettiCanvas}></canvas>
        </Fragment>
    )
}

export default Booked
